import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TimeInputWidthConstantType,
    TimeInputDynamicStyle
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const TIME_INPUT_DIGIT_COUNT = 2;

export const getTimeInputWidth = ({
    controlPaddings,
    controlHeights,
    borders
}: TimeInputWidthConstantType): number => {
    return controlHeights.small * 2 + (controlPaddings.small + borders.line) * 2;
};

const stylesheet = StyleSheet.create({
    input: {
        textAlignVertical: "center",
        verticalAlign: "middle",
        textAlign: "center",
        fontVariant: [
            "tabular-nums"
        ]
    },
    container: {
        flexShrink: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    controlPaddings,
    controlHeights,
    borders
}: TimeInputDynamicStyle) => {
    const styles = {
        container: {
            width: getTimeInputWidth({
                controlPaddings,
                controlHeights,
                borders
            })
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
